export default __webpack_public_path__ + "static/media/Site-Rarites_Image.757cf67b.png";